import { render, staticRenderFns } from "./addsocialChannel.vue?vue&type=template&id=4ac3773e&"
import script from "./addsocialChannel.vue?vue&type=script&lang=js&"
export * from "./addsocialChannel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\yujian_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ac3773e')) {
      api.createRecord('4ac3773e', component.options)
    } else {
      api.reload('4ac3773e', component.options)
    }
    module.hot.accept("./addsocialChannel.vue?vue&type=template&id=4ac3773e&", function () {
      api.rerender('4ac3773e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/indexDisposition/components/addsocialChannel.vue"
export default component.exports